import { Col, Icon, Row, Tooltip } from 'antd';
import classNames from 'classnames/bind';
import { RadioField } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import styles from './index.less';
import { setMergedData, setMasterRecord } from '../flow/actions';

const cx = classNames.bind(styles);
const {MasterKey, AntdGridMax, KeyTypes } = Enums;
const {OwnerKey, CreatedDateKey, LastModifiedKey, LastActivityKey } = KeyTypes


const defaultProps = {
  data: [],
  keys: [],
  mergedData: {},
};
const propTypes = {
  intl: intlShape.isRequired,
  data: PropTypes.array.isRequired,
  keys: PropTypes.array.isRequired,
  mergedData: PropTypes.object.isRequired,
  setMasterRecord: PropTypes.func,
  setMergedData: PropTypes.func,
};


class RadiosTable extends Component {
  state = {
    newKeys:[]
  }
  handleRadioChange = (key, value) => {
    const { setMergedData, setMasterRecord } = this.props;
    if (key === MasterKey) {
      return setMasterRecord(value);
    }
    return setMergedData(key, value);
  }

  reOrderKeysSequence = () => {
    let oldKeys = this.props.keys
    oldKeys.unshift(1,2,3,4,5)
    for(let i = 0; i<oldKeys.length; i++){
      switch(oldKeys[i].key){
        case MasterKey:
          oldKeys.splice(0,1,oldKeys[i])
          oldKeys.splice(i,1)
          i--;
          break;
        case OwnerKey: 
          oldKeys.splice(1, 1, oldKeys[i])
          oldKeys.splice(i,1)
          i--;
          break;
        case CreatedDateKey: 
          oldKeys.splice(2, 1, oldKeys[i])
          oldKeys.splice(i,1)
          i--;
          break;
        case LastModifiedKey:
          oldKeys.splice(3, 1, oldKeys[i])
          oldKeys.splice(i,1)
          i--;
          break;
        case LastActivityKey:
          oldKeys.splice(4, 1, oldKeys[i])
          oldKeys.splice(i,1)
          i--;
          break;
        default:
      }
    }

    return oldKeys
  }

  componentDidUpdate(prevState) {
    if(this.props.keys !== prevState.keys){
      this.setState({
        newKeys : this.reOrderKeysSequence()
      })
    }
  }

  render() {
    const {
      intl,
      data,
      keys,
      mergedData,
    } = this.props;
    const { formatMessage } = intl;
    const i18n = 'page.mergeLeads';

    const labelColLayout = {
      sm: 4,
    };
    const colLayout = {
      sm: Math.floor((AntdGridMax - labelColLayout.sm) / data.length),
    };

    const masterLabel = (
      <Fragment>
        <span>{formatMessage({ id: `${i18n}.master` })}</span>
        <Tooltip placement="right" title={formatMessage({ id: `${i18n}.aboutMaster` })}>
          <Icon
            className="ml-sm"
            size="small"
            style={{ color: 'red', fontWeight: '400' }}
            type="exclamation-circle"
          />
        </Tooltip>
      </Fragment>
    );

    return (
      <Fragment>
        {/* header with leads name */}
        <Row className={cx('row-header')}>
          {data.length > 0 && <Col className={cx('title')} {...labelColLayout} />}
          {data.map(record => (
            <Col className={cx('title')} key={record.id} {...colLayout}>
              {record.name}
            </Col>
          ))}
        </Row>
        {this.state.newKeys.map((key, index) => (
          <Row className={cx('row')} key={index}>
            {/* label col */}
            <Col key={MasterKey} {...labelColLayout}>
              <div className={`required ${cx('labelCol')} ${index < 5 ? cx('topSixBackground') : ''}`} key={key.key} title={key.label}>
                {key.key === MasterKey ? masterLabel : key.label}
              </div>
            </Col>
            {/* value cols */}
              {data.map(record => (
                <Col key={record.id} {...colLayout} className={`${index < 5 ? cx('topSixBackground') : ''}`}>      
                  <RadioField
                    key={key.key}
                    fieldKey={key}
                    data={record}
                    mergedData={mergedData}
                    onChange={this.handleRadioChange}
                  />
                </Col>
              ))}
          </Row>
        ))}
      </Fragment>
    );
  }
}


RadiosTable.defaultProps = defaultProps;
RadiosTable.propTypes = propTypes;
const mapStateToProps = ({ mergence }) => ({
  data: mergence.data,
  keys: mergence.keys,
  mergedData: mergence.mergedData,
});
const mapDispatchToProps = {
  setMergedData,
  setMasterRecord,
};
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RadiosTable));



// WEBPACK FOOTER //
// ./src/views/MergeLeads/components/RadiosTable.jsx